import React from "react";
import style from "./loadingCards.module.css";

const LoadingCards = () => {
    return (
        <div className={style.container}>
            <div className={style.loading}>
                <span className={style.image}></span>

                <div className={style.info}>
                    <span className={style.title}></span>
                    <span className={style.diets}></span>
                </div>
            </div>
            <div className={style.loading}>
                <span className={style.image}></span>

                <div className={style.info}>
                    <span className={style.title}></span>
                    <span className={style.diets}></span>
                </div>
            </div>
            <div className={style.loading}>
                <span className={style.image}></span>

                <div className={style.info}>
                    <span className={style.title}></span>
                    <span className={style.diets}></span>
                </div>
            </div>
            <div className={style.loading}>
                <span className={style.image}></span>

                <div className={style.info}>
                    <span className={style.title}></span>
                    <span className={style.diets}></span>
                </div>
            </div>
            <div className={style.loading}>
                <span className={style.image}></span>

                <div className={style.info}>
                    <span className={style.title}></span>
                    <span className={style.diets}></span>
                </div>
            </div>
            <div className={style.loading}>
                <span className={style.image}></span>

                <div className={style.info}>
                    <span className={style.title}></span>
                    <span className={style.diets}></span>
                </div>
            </div>
            <div className={style.loading}>
                <span className={style.image}></span>

                <div className={style.info}>
                    <span className={style.title}></span>
                    <span className={style.diets}></span>
                </div>
            </div>
            <div className={style.loading}>
                <span className={style.image}></span>

                <div className={style.info}>
                    <span className={style.title}></span>
                    <span className={style.diets}></span>
                </div>
            </div>
            <div className={style.loading}>
                <span className={style.image}></span>

                <div className={style.info}>
                    <span className={style.title}></span>
                    <span className={style.diets}></span>
                </div>
            </div>
            <div className={style.loading}>
                <span className={style.image}></span>

                <div className={style.info}>
                    <span className={style.title}></span>
                    <span className={style.diets}></span>
                </div>
            </div>
        </div>
    );
};

export default LoadingCards;
